import { Check } from "lucide-react";
import { PASSWORD_RULES } from "@/lib/password";

/**
 * Live password-requirements checklist: each rule ticks green as the password
 * satisfies it. Render directly under a new-password input so the user sees
 * exactly what's missing while typing.
 */
export function PasswordRequirements({ password, className = "" }: { password: string; className?: string }) {
  return (
    <ul className={`grid grid-cols-1 gap-x-4 gap-y-1 sm:grid-cols-2 ${className}`}>
      {PASSWORD_RULES.map((rule) => {
        const ok = rule.test(password);
        return (
          <li
            key={rule.id}
            className={`flex items-center gap-1.5 text-xs transition-colors duration-150 ${
              ok ? "font-medium text-emerald-500" : "text-muted-foreground"
            }`}
          >
            {ok ? (
              <Check className="h-3.5 w-3.5 shrink-0" />
            ) : (
              <span className="mx-1 h-1.5 w-1.5 shrink-0 rounded-full bg-muted-foreground/40" />
            )}
            {rule.label}
          </li>
        );
      })}
    </ul>
  );
}
